import axios from '@/axios/api.request'

export const imports = (form) => axios.request({
    url: '/office/salary/import',
    data: form,
    method: 'post'
  })